import { withNamespace } from "@/i18n/lazy-route"

/** The nightly ledger check (LLD §9.21, Task 6.2), with the `adminLedger` namespace. */
export const ReconciliationScreen = withNamespace(
  "adminLedger",
  () => import("./screens/ReconciliationScreen"),
  {
    en: () => import("@/i18n/locales/en/adminLedger.json"),
    fr: () => import("@/i18n/locales/fr/adminLedger.json"),
  },
)
